import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { loadingAction } from 'store/globalState/global';
import LoginComponents from '../components';
import { setAutoNavigation } from '../../MainPage/modules/mainPage';
import { doLogin, doLoginSocial } from '../modules/actions';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.login,
    loginError: state.login.error,
    userLang: state.i18n.language,
    app: state.app,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    doLogin: bindActionCreators(doLogin, dispatch),
    showLoading: bindActionCreators(loadingAction, dispatch),
    doLoginSocial: bindActionCreators(doLoginSocial, dispatch),
    setAutoNavigation: bindActionCreators(setAutoNavigation, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginComponents));



// WEBPACK FOOTER //
// ./src/routes/Login/container/index.js